import { createAction, props } from '@ngrx/store';

export const renameArticle = createAction(
  '[News Feed] Rename Article',
  props<{ id: string; title: string }>(),
);

export const renameArticleSuccess = createAction(
  '[News Feed] Rename Article Success',
  props<{ id: string; title: string }>(),
);
